export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Email"
    role="img"
    viewBox="0 0 512 512"
    height={20}
    width={20}
  >
    <rect
      width="512"
      height="512"
      rx="15%"
      fill="transparent"
    />
    <rect
      width="356"
      height="256"
      x="78"
      y="128"
      rx="8%"
      data-email-svg="true"
    />
    <path
      fill="none"
      strokeWidth="20"
      d="M434 128L269 292c-7 8-19 8-26 0L78 128m0 256l129-128m227 128L305 256"
      data-email-svg="true"
    />
  </svg>
);
